import type {User} from '#types/user.js';
import type {Organization, Team} from '#types/team.js';
import {useStore} from 'zustand';
import {createStore} from 'zustand/vanilla';
import type {Nullable} from '#types';
import type {Session} from '#types/session.js';

export type SessionStore = {
  session: Nullable<Session>;

  // TODO(joshua): deprecate types below in favor for slim session object
  user: Nullable<User>;
  org: Nullable<Organization>;
  team: Nullable<Team>;
  flags: Record<string, boolean>;

  isFlagEnabled: (flag: string) => boolean;
  setSession: (session: Nullable<Session>) => void;
  setUser: (user: Nullable<User>) => void;
  setOrg: (org: Nullable<Organization>) => void;
  setTeam: (team: Nullable<Team>) => void;

  // TODO: Improve this type
  setFlags: (flags: Record<string, boolean>) => void;
};

const createSessionStore = () =>
  createStore<SessionStore>((set, get) => ({
    session: null,
    user: null,
    org: null,
    team: null,
    flags: {},
    setSession: session => set({session}),
    setUser: user => set({user}),
    setOrg: org => set({org}),
    setTeam: team => set({team}),
    setFlags: flags => set(state => ({flags: {...state.flags, ...flags}})),
    isFlagEnabled: (flag: string) => {
      return get().flags[flag] ?? false;
    },
  }));

export const sessionStore = createSessionStore();

export const useSessionStore = <U = SessionStore>(
  selector?: (state: SessionStore) => U
) => {
  // @ts-expect-error - This works at runtime but TypeScript doesn't like the undefined selector
  return useStore(sessionStore, selector);
};
